import loadable from '@wix/yoshi-flow-editor/loadable'

export const RicosViewer = loadable(
  () => import(/* webpackPrefetch: true, webpackChunkName: "ricos-viewer" */ '../event-details/ricos-viewer'),
)
